module.exports = __webpack_public_path__ + "p3_img1.png?8c0fbc5ac325c17d142e152fee459405";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p3/p3_img1.png
// module id = 52
// module chunks = 0